var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletePolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132969",
    "data-name": "Group 132969",
    transform: "translate(-231 -1120)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7340",
    "data-name": "Rectangle 7340",
    width: 24,
    height: 24,
    transform: "translate(231 1120)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_128573",
    "data-name": "Group 128573",
    transform: "translate(-17784.039 -1833.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_177",
    "data-name": "Line 177",
    d: "M10.925-.025H-.387A.363.363,0,0,1-.75-.387.363.363,0,0,1-.387-.75H10.925a.363.363,0,0,1,.363.363A.363.363,0,0,1,10.925-.025Z",
    transform: "translate(18021.77 2959.79)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91141",
    "data-name": "Path 91141",
    d: "M87.721,2.232h4.125a.448.448,0,0,1,.447.447V4.766h-5.02V2.679A.448.448,0,0,1,87.721,2.232Zm3.847.725H88V4.04h3.569Z",
    transform: "translate(17937.254 2955)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91142",
    "data-name": "Path 91142",
    d: "M82.678,9.312H90.29a1.795,1.795,0,0,1,1.791,1.918l-.626,9.085a1.8,1.8,0,0,1-1.791,1.672H83.3a1.8,1.8,0,0,1-1.79-1.672l-.626-9.085a1.794,1.794,0,0,1,1.79-1.918Zm6.986,11.949a1.073,1.073,0,0,0,1.067-1l.626-9.085a1.069,1.069,0,0,0-1.067-1.143H82.678a1.069,1.069,0,0,0-1.066,1.143l.626,9.085a1.072,1.072,0,0,0,1.066,1Z",
    transform: "translate(17940.553 2951.344)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_178",
    "data-name": "Line 178",
    d: "M-.387,6.952A.363.363,0,0,1-.75,6.589V-.387A.363.363,0,0,1-.387-.75a.363.363,0,0,1,.363.363V6.589A.363.363,0,0,1-.387,6.952Z",
    transform: "translate(18025.277 2963.823)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_179",
    "data-name": "Line 179",
    d: "M-.387,6.952A.363.363,0,0,1-.75,6.589V-.387A.363.363,0,0,1-.387-.75a.363.363,0,0,1,.363.363V6.589A.363.363,0,0,1-.387,6.952Z",
    transform: "translate(18027.426 2963.823)",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_180",
    "data-name": "Line 180",
    d: "M-.387,6.952A.363.363,0,0,1-.75,6.589V-.387A.363.363,0,0,1-.387-.75a.363.363,0,0,1,.363.363V6.589A.363.363,0,0,1-.387,6.952Z",
    transform: "translate(18029.572 2963.823)",
    fill: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePolicy);
export default __webpack_public_path__ + "static/media/delete_policy.e360cd3e02474b627b32a46f6f00e32d.svg";
export { ForwardRef as ReactComponent };